var ezdia;
(function (ezdia) {
    var editTemplate = function () {
        var ret = "    <div class=\"ez-inline-editor-btn-nav clearfix\">\n      <i class=\"fa fa-arrows-alt\" data-handle=\"move\"></i><i class=\"fa fa-trash-o\" data-handle=\"remove\"></i>\n    </div>";
        return ret;
    };
    var templateOptionsItems = function (modules, name) {
        var e_1, _a;
        var ret = '';
        var selected = 'selected';
        try {
            for (var _b = __values(Object.entries(modules)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], obj = _d[1];
                var label = obj.label;
                if (label) {
                    ret += "<li class=\"division\"></li>\n        <li href=\"#ez_js_sys_inline_editor_" + key + "_" + name + "\"\n          data-list-group-item data-value=\"" + key + "\"\n          class=\"" + selected + "\"\n          data-toggle=\"tab\">" + label + "</li>";
                }
                selected = '';
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return ret;
    };
    var templateOptionsContent = function (modules, name) {
        var e_2, _a;
        var ret = '';
        var selected = 'active';
        try {
            for (var _b = __values(Object.entries(modules)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], obj = _d[1];
                var _e = obj, label = _e.label, template = _e.template;
                if (label) {
                    ret += "<div id=\"ez_js_sys_inline_editor_" + key + "_" + name + "\" class=\"tab-pane " + selected + "\">\n          " + template + "\n         </div>";
                    selected = '';
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return ret;
    };
    var templateOptions = function (context) {
        var id = context.id, modules = context.modules, name = context.name;
        var ret = "<div id=\"" + id + "\">\n      <div class=\"row\">\n        <div class=\"ez-inline-editor-template-options\">\n          <ul class=\"list-unstyled\"> " + templateOptionsItems(modules, name) + "</ul>\n        </div>\n        <div class=\"ez-inline-editor-template-tab-content\">\n          <div class=\"tab-content\">" + templateOptionsContent(modules, name) + "</div>\n        </div>\n      </div>\n    </div>";
        return ret;
    };
    var templates;
    (function (templates) {
        templates.inlineEditor = {
            editTemplate: editTemplate,
            templateOptions: templateOptions
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
